import { useCheckoutStore } from '@/shared/store/checkoutStore'

const checkoutStore = useCheckoutStore()

export default checkoutStore

export type CheckoutState = ReturnType<typeof checkoutStore['state']>
